import React from 'react'
import SubHeader from '../components/SubHeader'
import AboutUs from '../components/AboutUs'
import VisionMission from '../components/VisionMission'
import BestSelling from '../components/BestSelling'
import Testimonials from '../components/Testimonials'
import OurTeam from '../components/OurTeam'
import HowWeWork from '../components/HowWeWork'
import Faq from '../components/Faq'
import OurClinets from '../components/OurClinets'
const About = () => {
  return (
    <>
      <SubHeader />
      <AboutUs />
      <VisionMission />
      <BestSelling />
      <Testimonials />
      {/* <OurTeam /> */}
      <HowWeWork />
      <Faq />
      <OurClinets />
    </>
  )
}

export default About
